/// <amd-module name="Pipelines/Jira/Utility/Utility" />

import { IJiraQueryParameters } from "Pipelines/Jira/Common/Types";

import { Uri } from "VSS/Platform/Util/Url";

export class Utility {

    /**
     * Get url search parameters, where window.location.href will be the url of our Jira configuration UX api, in which jwt and xdm_e and few other 
     * query params get added by Jira before calling this api. We will store this jwt and xdm_e and append as query params for further api calls like
     * delete project api for validation purpose as all these apis will be anonymous.
     */
    public static getJiraSearchQueryParams(): IJiraQueryParameters {
        let uri = new Uri(window.location.search);
        
        var queryParams: IJiraQueryParameters = {
            jwt: uri.getQueryParam('jwt') || "",
            xdm_e: uri.getQueryParam('xdm_e') || ""
        };

        return queryParams;
    }
}